import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from "reactstrap";
import { useSelector } from "react-redux";
import connectIps from "../../../../assets/connectips-logo.png";

const OrderSummary = ({ isOpen, toggle }) => {
  const cartItems = useSelector((state) => state.Cart.items);
  console.log("🚀 ~ OrderSummary ~ cartItems:", cartItems);

  // Calculate total
  const total = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  return (
    <Modal isOpen={isOpen} size="lg" toggle={toggle} centered>
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody>
        <Col>
          {/* Order Summary Card */}
          <Card className="mb-4">
            <CardHeader>
              <div className="d-flex">
                <div className="flex-grow-1">
                  <h5 className="card-title mb-0">Order Summary</h5>
                </div>
              </div>
            </CardHeader>
            <CardBody>
              <div className="table-responsive table-card">
                <table className="table table-borderless align-middle mb-0">
                  <thead className="table-light text-muted">
                    <tr>
                      <th style={{ width: "90px" }} scope="col">
                        Product
                      </th>
                      <th scope="col">Product Info</th>
                      <th scope="col" className="text-end">
                        Price
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {cartItems.map((item, key) => (
                      <React.Fragment key={key}>
                        <tr>
                          <td>
                            <div className="avatar-md bg-light rounded p-1">
                              <img
                                // src={item.fullUrl || item.imagePath}
                                src={item.displayImage.getCDNUrl()}
                                alt={item.title}
                                className="img-fluid d-block"
                              />
                            </div>
                          </td>
                          <td>
                            <h5 className="fs-15">
                              <a
                                href="/apps-ecommerce-product-details"
                                className="text-body"
                              >
                                {item.title}
                              </a>
                            </h5>
                            <p className="text-muted mb-0">
                              {item.currency || "NRS."} {item.price} x{" "}
                              {item.quantity}
                            </p>
                          </td>
                          <td className="text-end">
                            {item.currency || "Rs."}{" "}
                            {item.price * item.quantity}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                    <tr className="table-active">
                      <th colSpan="2">Total:</th>
                      <td className="text-end">
                        <span className="fw-semibold">
                          {cartItems[0]?.currency || "Rs."} {total}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>

          {/* Payment Selection Card */}
          <Card>
            <CardBody>
              <h5 className="mb-3">Payment Method</h5>
              <Row>
                <Col lg={6} sm={12}>
                  <div className="form-check card-radio">
                    <input
                      id="paymentMethod"
                      name="paymentMethod"
                      type="radio"
                      className="form-check-input"
                      defaultChecked
                    />
                    <label className="form-check-label" htmlFor="paymentMethod">
                      <span className="fs-16 text-muted me-2">
                        <img
                          src={connectIps}
                          alt="ConnectIPS"
                          className="align-bottom"
                          style={{ height: "25px" }}
                        />
                      </span>
                      <span className="fs-14 text-wrap">Connect IPS</span>
                    </label>
                  </div>
                </Col>
              </Row>
              <div className="mt-4 d-flex justify-content-end">
                <Button
                  color="danger"
                  style={{ width: "125px" }}
                  onClick={toggle}
                  className="me-2"
                >
                  Cancel
                </Button>
                <Button style={{ width: "125px" }} color="primary">
                  Make Payment
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </ModalBody>
    </Modal>
  );
};

export default OrderSummary;
